import { $editingClientNote } from './states';
import { setEditingClientNote } from './events';

// Set editing client note
$editingClientNote.on(setEditingClientNote, (_, editingClientNote) => editingClientNote);
